import { render, staticRenderFns } from "./MixingValve.vue?vue&type=template&id=19096613&scoped=true&"
import script from "./MixingValve.vue?vue&type=script&lang=ts&"
export * from "./MixingValve.vue?vue&type=script&lang=ts&"
import style0 from "./MixingValve.vue?vue&type=style&index=0&id=19096613&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19096613",
  null
  
)

export default component.exports